module.exports = __webpack_public_path__ + "static/media/_pong_golf.1fd4d05f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/_pong_golf.png
// module id = 291
// module chunks = 0